import { createAsyncAction, createAction } from 'redux-promise-middleware-actions';
import { addAsyncActionPostfixes } from '../utils/actionTypeCreator';
import { tneAxiosClient } from '../api/apiSettings';

export const types = {
  ...addAsyncActionPostfixes({
    GET_PARTICULAR_TIMESHEET: 'GET_PARTICULAR_TIMESHEET',
    CHECK_UNCHECK: 'CHECK_UNCHECK',
    CREATE_NEW_TIMESHEET: 'CREATE_NEW_TIMESHEET',
    GET_PENDING_TANDE_COUNTS: 'GET_PENDING_TANDE_COUNTS',
    GET_TANDE_COUNTS_CONTRACTOR: 'GET_TANDE_COUNTS_CONTRACTOR',
    GET_TIMESHEET_APPROVER_REQUEST: 'GET_TIMESHEET_APPROVER_REQUEST',
    GET_TIMESHEET_VALIDATION: 'GET_TIMESHEET_VALIDATION',
    SAVE_COMMENT: 'SAVE_COMMENT',
    UPDATE_COMMENT: 'UPDATE_COMMENT',
    DELETE_COMMENT: 'DELETE_COMMENT',
    DELETE_TIMESHEET_SECTION: 'DELETE_TIMESHEET_SECTION'
  }),
  UPDATE_GENERAL_DATA: 'UPDATE_GENERAL_DATA',
  ADD_NEW_SECTION: 'ADD_NEW_SECTION',
  UPDATE_TIMESHEET: 'UPDATE_TIMESHEET',
  DELETE_TIMESHEET_LINE: 'DELETE_TIMESHEET_LINE',
  RESTORE_DELETED_TIMESHEET_LINE: 'RESTORE_DELETED_TIMESHEET_LINE',
  CLEAR_TIMESHEET_DATA: 'CLEAR_TIMESHEET_DATA',
  CHANGE_STATUS: 'CHANGE_STATUS',
  CHANGE_PERDIEM: 'CHANGE_PERDIEM',
  CHANGE_PART_OF_PERDIEM: 'CHANGE_PART_OF_PERDIEM',
  UPDATE_ATTACHMENTS: 'UPDATE_ATTACHMENTS',
  SAVE_SUCCESS: 'SAVE_SUCCESS',
  SUBMIT_SUCCESS: 'SUBMIT_SUCCESS',
  SET_SELECTED_SECTION: 'SET_SELECTED_SECTION'
};

export const getTimesheet = createAsyncAction(types.GET_PARTICULAR_TIMESHEET, (timesheetId) => {
  return tneAxiosClient.get(`v1/timesheet?timesheetId=${timesheetId}`).then((res) => res.data.Data);
});

export const updateTimesheet = createAction(types.UPDATE_TIMESHEET, (timesheet, sectionId, isSplitApprovalFlow) => ({
  Data: timesheet,
  SectionId: sectionId,
  IsSplitApprovalFlow: isSplitApprovalFlow
}));
export const updateAttachments = createAction(types.UPDATE_ATTACHMENTS, (sectionId, file, tempData) => ({
  SectionId: sectionId,
  File: file,
  TempData: tempData
}));

export const deleteLineById = createAction(types.DELETE_TIMESHEET_LINE, ({ id, sectionId, isSplitApprovalFlow }) => ({
  id,
  sectionId,
  isSplitApprovalFlow
}));

export const restoreDeletedTimesheetLine = createAction(types.RESTORE_DELETED_TIMESHEET_LINE, (line) => ({ line }));

export const updateGeneralData = createAction(types.UPDATE_GENERAL_DATA, (prop, value) => ({
  Data: { prop, value }
}));

export const checkUncheckAllRows = createAction(types.CHECK_UNCHECK, (timesheets) => timesheets);

export const addNewTimesheet = createAction(types.CREATE_NEW_TIMESHEET, (sectionId, isSplitApprovalFlow) => ({
  sectionId,
  isSplitApprovalFlow
}));

export const addNewSection = createAction(types.ADD_NEW_SECTION);

export const clearTimesheet = createAction(types.CLEAR_TIMESHEET_DATA);

export const saveComment = createAsyncAction(
  types.SAVE_COMMENT,
  (comment, timesheetId, IsSplitApprovalFlow, SectionId) => {
    return tneAxiosClient
      .post(`v1/approver-comment`, { TimesheetId: timesheetId, Reason: comment, TimesheetSectionId: SectionId })
      .then((res) => {
        return {
          ...res.data.Data,
          IsSplitApprovalFlow
        };
      });
  }
);

export const updateComment = createAsyncAction(
  types.UPDATE_COMMENT,
  (comment, commentId, IsSplitApprovalFlow, TimesheetSectionId) => {
    return tneAxiosClient
      .put(`v1/approver-comment`, { Id: commentId, Reason: comment, TimesheetSectionId })
      .then(() => ({ comment, commentId, IsSplitApprovalFlow, TimesheetSectionId }));
  }
);

export const deleteRejectionComment = createAsyncAction(
  types.DELETE_COMMENT,
  (commentId, SectionId, IsSplitApprovalFlow, cb) => {
    return tneAxiosClient.delete(`v1/approver-comment?approverCommentId=${commentId}`).then(() => {
      cb();
      return {
        commentId,
        SectionId,
        IsSplitApprovalFlow
      };
    });
  }
);

export const getTandEPendingCounts = createAsyncAction(types.GET_PENDING_TANDE_COUNTS, () => {
  return tneAxiosClient.get(`v1/get-tne-count`).then((res) => res.data.Data);
});

export const getTandECountsContractor = createAsyncAction(types.GET_TANDE_COUNTS_CONTRACTOR, () => {
  return tneAxiosClient.get(`v1/get-tne-count-contractor`).then((res) => res.data.Data);
});

export const changeStatus = createAction(types.CHANGE_STATUS, (status, sectionId) => ({ status, sectionId }));

export const changePerDiem = createAction(types.CHANGE_PERDIEM, (payload) => payload);

export const setSaveSuccess = createAction(types.SAVE_SUCCESS, (success) => success);
export const setSubmitSuccess = createAction(types.SUBMIT_SUCCESS, (success) => success);
export const setSelectedSectionData = createAction(types.SET_SELECTED_SECTION, (data) => data);

export const changePartOfPerDiem = createAction(types.CHANGE_PART_OF_PERDIEM, (newPerDiemPart) => newPerDiemPart);

export const getTimeExpenseValidation = createAsyncAction(types.GET_TIMESHEET_VALIDATION, (companyId, jobId) => {
  return tneAxiosClient.get(`v1/tande-validation?compnayId=${companyId}&jobId=${jobId}`).then((res) => res.data.Data);
});

export const deleteSection = createAsyncAction(types.DELETE_TIMESHEET_SECTION, (sectionId) => {
  return typeof sectionId === 'number'
    ? tneAxiosClient.delete(`v1/timesheet/section?sectionId=${sectionId}`).then(() => sectionId)
    : Promise.resolve(sectionId);
});
